exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#budget_alerts_create .pretty.p-default input:checked ~ .state label::after {\n  background-color: #049bdd !important;\n}\n#budget_alerts_create .pretty.p-switch input:checked ~ .state label::after {\n  background-color: #049bdd !important;\n}\n#budget_alerts_create .pretty {\n  line-height: 1 !important;\n}", ""]);

// exports
